import Cookies from 'js-cookie'

const TokenKey = 'loginToken'
const UseridKey = 'loginUserid'
const SessionKey = 'sessionkey'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getUserid() {
  return Cookies.get(UseridKey)
}

export function setUserid(userid) {
  return Cookies.set(UseridKey, userid)
}

export function removeUserid() {
  return Cookies.remove(UseridKey)
}

export function getSessionKey() {
  return Cookies.get(SessionKey)
}

export function setSessionKey(sessionKey) {
  return Cookies.set(SessionKey, sessionKey)
}

export function removeSessionKey() {
  return Cookies.remove(SessionKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js